///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { order } from "./types";

const getSortOrder = (field, sortColumn, sortOrder) => {
  if (field === sortColumn) {
    if (sortOrder === order.ascending) {
      return order.descending;
    }
    if (sortOrder === order.descending) {
      return "";
    }
  }
  return order.ascending;
};

export default getSortOrder;
